<div class="row align-items-center" style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
  <div class="col">
    <div class="eventsheader">Create Advertisement</div>
  </div>
  
</div>

<div style="background-color:rgb(241, 235, 228);">
<form  [formGroup]="adsForm">
  <div class="container ">
    <div class="row">
      <div class="col">
        <div class="row">

          <mat-form-field appearance="outline">
            <mat-label>Ad Name*</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>

        </div>
    
        <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Short Description (max: 75 characters)</mat-label>
              <textarea maxlength="75" formControlName="description" matInput ></textarea>
            </mat-form-field>
  
          </div>


        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Url*</mat-label>
            <input matInput formControlName="url" >
          </mat-form-field>


        </div>

        <div *ngIf="false" class="row">
          <form [formGroup]="countryFormGroup">
            <mat-select-country appearance="outline" [countries]="predefinedCountries" label="" formControlName="country"
            (onCountrySelected)="onCountrySelected($event)"
                >
            </mat-select-country>
        </form>
        </div>

        <div class="row">
          <div >
            <label (click)="fileInput.click()" class="uploadimagetext">Upload Image*</label>
            <br>
            <!-- <i style="cursor: help;" matTooltip="For a better resolution and fit, we recommend uploading a square picture">Recommended ratio 1:1</i> -->

            <!-- <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" /> -->
            <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
              [uploader]="uploader" />

            <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
            <div (click)="fileInput.click()" class="imagecontainer">

              <img class="uploadedimage" [src]="url" *ngIf="url"></div>
            <i>Supported formats (JPG, PNG, GIF, TIFF) with a maximum size of 5 MB</i>
          </div>
        </div>

        <div class="row align-items-center" >
          <div class="container"> 
            <mat-label style="font-weight: bold;">Choose package</mat-label>              
            <div class="row align-items-center">                   
                <div class="col-sm" *ngFor="let package of packages"  >
                    <div class="package" 
                    [class.highlighted]="package === highlightedPackage" 
                    (click)="highlightedPackage = package" (click)="choosePackage(package.id)" >
                    <!-- <img class="packageimage" src="{{package.image}}">  -->
                        <div class="packageheader">
                            {{package.name}}
                        </div>                    
                    <div class="packagecontent">
                        <label class="packagedays">{{package.days}} days</label><br>
                        <label class="packageprice">{{package.cost}}$</label>
                    </div>

                </div>
                </div>

            </div>

          </div>
        </div>
      </div>




      <div class="col-md-5 col-md-offset-2">

        <div class="row">
          <h5 style="margin-top: 20px; margin-left: 10px;">Rules and Regulations:</h5>
          <ul>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
            laoreet
            dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper
            suscipit lobortis nisl ut aliquip ex ea commodo consequat.</ul>
          <ul>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
            laoreet
            dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper
            suscipit lobortis nisl ut aliquip ex ea commodo consequat.</ul>
          <ul>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
            laoreet
            dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper
            suscipit lobortis nisl ut aliquip ex ea commodo consequat.</ul>
        </div>



      </div>




    </div>
  </div>
  <div class="row align-items-center">
    <button class="submitbutton" mat-raised-button (click)="submitAd()" type="submit">Submit Ad Request</button>
  </div>
</form>

<!-- <div>
  <h2>My Ads</h2>
    <div class="col">  <div class="cont" *ngFor="let ad of myCreatedAds">
    <div class="myadelement">Name: {{ad.name}}</div>
    <div class="myadelement">Description: {{ad.description}}</div>
    <div class="myadelement">Link: {{ad.link}}</div>
    <div class="myadelement">Status: {{ad.status}}</div>
    <div class="myadelement">Package: {{ad.ad_package[0].package[0].name}}</div>
    <img class="myadelement" style="width: 100px;" src="{{'https://events.globalistic.tech/'+ ad.image}}">
  </div>

</div>
</div> -->
</div>